import React from 'react';
import { withApi } from '@tencent/react-aio';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import { History } from 'history';
import { UserSale } from '@/model/user';
import { OrdersItem } from '@/model/orders';
import { SMB_FLAG } from '@/constants/Constants';
import LinkButton from '@/components/LinkButton';
import RegistrationStatusInfo from '@/pages/agency/register/components/RegistrationStatusInfo';
import WithPermission from '@/common/permissions/WithPermission';
import { isContain } from '@/utils/ParamUtils';
import CreateAccountOrderModal from '@/pages/orders/CreateAccountOrderModal';
import AccountApplyModal from '@/pages/orders/AccountApplyModal';
import Delegate from '@/components/Delegate';
import fePerms from '@/common/permissions/sale/fePerms';
// import "./style.scoped.less"

interface WhiteList {
  data: number[];
}

interface CustomerData {
  customerId: number; // 账户id
  customerMpAppId: string; // wxAppid
  customerMpUserName: string; // 视频号id or wx原始id
  customerUnibdAppId: string; // 附近推id
}

interface CustomerIdViewProps {
  operateDisabled: boolean; // 可操作是否禁止
  customerData: CustomerData;
  webApi: {
    searchProtectionInfo: () => any
  };
  whiteList: WhiteList; // 直销白名单
  loginStatus: UserSale;
  data: OrdersItem;
  history: History;
  callback: () => void;
}

interface CustomerIdViewState {
  protectionInfo: {
    smb_flag?: number;
  };
  customerData: CustomerData;
}

class CustomerIdView extends React.PureComponent<CustomerIdViewProps, CustomerIdViewState> {
  private createAccountOrderModal: React.RefObject<any>;
  private accountApplyModal: React.RefObject<any>;
  constructor(props: CustomerIdViewProps) {
    super(props);
    this.state = {
      protectionInfo: {},
      customerData: props.customerData || {},
    };
    this.createAccountOrderModal = React.createRef();
    this.accountApplyModal = React.createRef();
  }

  componentDidMount() {
    this.getProtectionInfo();
  }

  componentWillReceiveProps(nextProps: CustomerIdViewProps) {
    if (this.state.customerData?.customerMpAppId !== nextProps.customerData?.customerMpAppId) {
      this.setState({ customerData: nextProps.customerData }, () => {
        this.getProtectionInfo();
      });
    }
  }

  /**
   * @description: 查询客保状态
   */
  getProtectionInfo = () => {
    const { webApi, customerData, whiteList, loginStatus, data } = this.props;
    const isDirectSales = _.includes(whiteList.data, loginStatus.agencyId);
    const { customerMpAppId } = customerData || {};
    if (!customerMpAppId || !isDirectSales || (customerMpAppId && !customerMpAppId.startsWith('wx'))) return;
    webApi
      .searchProtectionInfo()
      .ajaxJson({
        data: {
          appid: customerData.customerMpAppId,
          leadId: data.leadId,
        },
      })
      .then((res: { ret: number; data: object; }) => {
        if (res && res.ret === 0) {
          this.setState({
            protectionInfo: res.data,
          });
        }
      })
      .catch((err: {}) => {
        this.setState({ protectionInfo: {} });
      });
  };

  /**
   * @description: 提交开户资料
   */
  createAccountOrder = (id: number, data: OrdersItem) => {
    this.createAccountOrderModal.current.show({
      refreshTable: this.props.callback,
      id,
      leadData: data,
      type: 'create',
    });
  };

  /**
   * @description: 开户提交申请
   */
  askAccountApply = (data: OrdersItem, applyStatus: string) => {
    this.accountApplyModal.current.show({
      onSubmit: this.props.callback,
      applyStatus,
      data,
    });
  };

  renderOpenAction = () => {
    const { data } = this.props;
    if (!data) return null;
    return <React.Fragment>
      <WithPermission reject={!isContain(data.permissions, fePerms.REGISTRATION_CREATE)}>
        <LinkButton onClick={() => this.createAccountOrder(data.leadId, data)}>提交开户资料</LinkButton>
      </WithPermission>
      <WithPermission reject={!isContain(data.permissions, fePerms.REGISTRATION_SUBMIT)}>
        <LinkButton onClick={() => this.askAccountApply(data, 'create')}>提交开户</LinkButton>
      </WithPermission>
    </React.Fragment>;
  };

  renderCustomerId = () => {
    const {
      customerData: {
        customerId,
        customerMpAppId,
        customerMpUserName,
        customerUnibdAppId,
      },
      whiteList,
      loginStatus,
      data,
      history,
      operateDisabled,
    } = this.props;
    const { lastRegistrationTicket, lastRegistrationTicketId, leadId } = data.lead || {};
    const { protectionInfo: { smb_flag } } = this.state;
    // 是否为直销
    const isDirectSales = _.includes(whiteList.data, loginStatus.agencyId);
    if (isDirectSales) { // 直销
      return <span>
        {customerId}
        {/* { typeof smb_flag === 'number' && customerMpAppId && customerMpAppId.startsWith('wx') ? SMB_FLAG[smb_flag] : ''}*/}
      </span>;
    }
    if (customerMpAppId) { // 有账户id(mp)
      return <span>
          {customerId}
          {
            !operateDisabled && this.renderOpenAction()
          }
        </span>;
    }
    if (!customerId) { // 无账户id
      if (lastRegistrationTicketId && lastRegistrationTicket?.status) { // 有开户单
        if (!operateDisabled) {
          return <div style={{ display: 'flex' }}>
              <RegistrationStatusInfo value={lastRegistrationTicket.status} />
              <WithPermission reject={!isContain(data.permissions, fePerms.REGISTRATION_DETAIL)}>
                <LinkButton
                  onClick={() => {
                    this.props.history.push(`/registration/register/detail?leadId=${leadId}&ticketId=${lastRegistrationTicketId}`);
                  }}
                >
                  查看开户单
                </LinkButton>
              </WithPermission>
              {this.renderOpenAction()}
            </div>;
        }
        return <RegistrationStatusInfo value={lastRegistrationTicket.status} />;
      }
      if (!operateDisabled) return this.renderOpenAction();
      return null;
    }
    return <span>{customerId}</span>;
  };

  render() {
    return (
      <span className="customer-id-view">
        {this.renderCustomerId()}
        <Delegate ref={this.createAccountOrderModal} component={CreateAccountOrderModal} />
        <Delegate ref={this.accountApplyModal} component={AccountApplyModal} />
      </span>
    );
  }
}

function mapStateToProps(state: {
  customerProtectionWhiteList: WhiteList;
  loginStatus: UserSale;
}) {
  return {
    whiteList: state.customerProtectionWhiteList,
    loginStatus: state.loginStatus,
  };
}

export default withRouter(withApi(connect(mapStateToProps, {})(CustomerIdView)));
